// ============================================================================
// Listening practice TXT export.
//
// Used on BOTH the question page (during/after practice) and the results page,
// so an export button is always available. The file includes the audio name,
// export date, every question (with options), the user's answers where known,
// the answer key, and the full transcript.
// ============================================================================

import { ListeningQuestion } from '../config/api';
import { downloadText } from './download';

const TYPE_LABEL: Record<string, string> = {
  tf: 'True / False',
  mcq: 'Multiple choice',
  short: 'Short answer',
};

interface ExportOptions {
  audioName: string;
  transcript: string;
  questions: ListeningQuestion[];
  // id -> the user's chosen/typed answer (absent on a fresh question page).
  userAnswers?: Record<string, string>;
}

function sanitizeFilename(name: string): string {
  return (name || 'listening-practice').replace(/[^a-zA-Z0-9-_ .]+/g, '_').slice(0, 80).trim() || 'listening-practice';
}

export function exportListeningTxt({ audioName, transcript, questions, userAnswers = {} }: ExportOptions): void {
  const lines: string[] = [];
  lines.push('Listening Practice');
  lines.push('==================');
  lines.push(`Audio file: ${audioName}`);
  lines.push(`Exported: ${new Date().toLocaleString()}`);
  lines.push(`Questions: ${questions.length}`);
  lines.push('');

  lines.push('Questions & Answers');
  lines.push('-------------------');
  questions.forEach((q, i) => {
    lines.push(`${i + 1}. [${TYPE_LABEL[q.type] || q.type}] ${q.question}`);
    if (q.options && q.options.length > 0) {
      q.options.forEach((opt) => lines.push(`   - ${opt}`));
    }
    const userAnswer = userAnswers[q.id];
    if (userAnswer !== undefined && userAnswer !== '') {
      lines.push(`   Your answer: ${userAnswer}`);
    }
    lines.push(`   Correct answer: ${q.correct_answer}`);
    lines.push('');
  });

  lines.push('Full Transcript');
  lines.push('---------------');
  lines.push(transcript || '(no transcript)');

  downloadText(`${sanitizeFilename(audioName)}.txt`, lines.join('\n'));
}
